import useUserStore from '@/stores/userStore';
import { useConfirm } from '@/components/confirm-dialog/confirm-manager';

export default function useLogout() {
  const { logout } = useUserStore();
  const confirm = useConfirm();

  const handleLogout = async (forceReload = false) => {
    return logout(forceReload);
  };

  const handleLogoutWithConfirm = async (forceReload = false) => {
    const res = await confirm({
      title: 'Are you sure you want to log out?',
      message: '',
      showCancel: true,
      okText: 'Log Out',
      cancelText: 'Cancel',
      danger: true,
    });
    if (!res) {
      return;
    }
    return logout(forceReload);
  };

  return {
    handleLogout,
    handleLogoutWithConfirm,
  };
}
